<template>
    <div  class="main_right_sidesec " >
        <div class="whiteBG pt-3 border radius mb-3">
            {{tabActiveFunction}}
            <div class="map-nav border-bottom pb-2 d-flex align-items-center justify-content-between">
                <ul class="d-flex align-items-center">
                    <li :class="(loadServiceRequest == 'requestServiceElement')? 'active' : ''">
                        <a  data-toggle="tab" href="" v-on:click="enableRequestElement('requestServiceElement')" >
                            {{$t('requestServices')}}
                        </a>
                    </li>
                    <li :class="(loadServiceRequest == 'openRequest')? 'active' : ''">
                        <a data-toggle="tab" href="" v-on:click="enableRequestElement('openRequest')" >
                            {{$t('OpenRequests')}}
                        </a>
                    </li>
                    <li :class="(loadServiceRequest == 'closeRequest')? 'active' : ''">
                        <a data-toggle="tab" href="" v-on:click="enableRequestElement('closeRequest')" >
                            {{$t('ClosedRequests')}} 
                        </a>
                    </li>
                </ul>
            </div> 
        </div>
         
        <div class="tab-content"> 
            <div  class="tab-pane whiteBG pt-3 border supportpagetab radius mb-3" :class="loadServiceRequest == 'requestServiceElement' ? ' in active' : ''">
                <app-request-services v-if="loadServiceRequest == 'requestServiceElement'"></app-request-services>
            </div>
            <!----- --open-ticket-component-- --->
            <div  class="tab-pane" :class="loadServiceRequest == 'openRequest' ? ' in active' : ''">
                <app-ticket-support v-if="loadServiceRequest == 'openRequest'"></app-ticket-support>
            </div>
            <!---- --------close-ticket-component----- -->
            <div  class="tab-pane" :class="loadServiceRequest == 'closeRequest' ? ' in active' : ''">
                <app-ticket-support v-if="loadServiceRequest == 'closeRequest'"></app-ticket-support>
            </div>
        </div>
         
    </div>
</template>
<script>      
    import { fxViewMixins } from '@/plugins/fxView'  
    import { Const } from '@/plugins/fxView/provider/candle-history/lib/const.cls'
    import requestServices from './request_services'
    import ticketSupport from './support'
    export default {
        name: 'SERVICES',
        mixins: [fxViewMixins],
        data () {
          return {
            loadServiceRequest : "requestServiceElement",
            ticket_status : "",
            pageLoader : false,
            loaderFuncRun : '1'
          }
        }, 
        components: {
            appRequestServices: requestServices,
            appTicketSupport: ticketSupport
        },
        computed:{
            tabActiveFunction(){
                localStorage.setItem("tabName", this.$route.params.tabName);
                this.loadServiceRequest = localStorage.getItem("tabName", this.$route.params.tabName);
                this.ticket_status = (this.loadServiceRequest == 'openRequest' ? '0' : '3')
            }
        },
        methods:{
            enableRequestElement(elementName){
			console.log(elementName)
                this.loadServiceRequest = elementName
                this.$router.replace({ name: "fxView.support", params: {tabName:elementName}})
            },
            
        },
        created(){
            if(this.$store.getters[Const.GET_TICKET_REASON_LIST] != ''){
                this.loaderFuncRun = '0'
            }
            this._runGetTicketReasonList({ 'globalParams' :{ },'localParams' :{"parameter" : this ,'loaderFuncRun' : this.loaderFuncRun}})
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/fxView/supports/index.vue